import ReactPixel from 'react-facebook-pixel';


const pixelId = '1145430471038149';

const advancedMatching = {}; 
const options = {
  autoConfig: true,
  debug: false,
};

export const initFacebookPixel = () => {
  ReactPixel.init(pixelId, advancedMatching, options);
  ReactPixel.pageView(); 
};


export const trackPageView = () => {
  ReactPixel.pageView();
};

export const trackEvent = (eventName, data = {}) => {
  ReactPixel.track(eventName, data);
};


export const trackPurchase = (amount) => {
  ReactPixel.track('Purchase', {
    value: Number(amount),
    currency: 'MKD',
  });
};

export const trackAddToCart = (productName, price) => {
  ReactPixel.track('AddToCart', {
    content_name: productName,
    value: price,
    currency: 'MKD',
  });
};
